import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import React from 'react'

const ClearAllConfirmationModal = ({
  openClearAllConfirmation,
  setOpenClearAllConfirmation,
  assignee,
  handleClearAssignments,
}) => {
  const handleModalClose = () => {
    setOpenClearAllConfirmation(false)
  }

  return (
    <Dialog
      open={openClearAllConfirmation}
      onClose={handleModalClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        Are you sure you want to clear all assignments for{' '}
        <span style={{ fontWeight: 'bold' }}>
          {assignee?.first_name} {assignee?.last_name}
        </span>
        ?
      </DialogTitle>

      <DialogActions>
        <Button color="primary" variant="outlined" onClick={handleModalClose}>
          No
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={(e) => handleClearAssignments(assignee.id)}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ClearAllConfirmationModal
